import KatalLogger, { Level } from '@amzn/katal-logger';

const katalLoggerConfig = {
  // This url string gets replaced with an actual value during deployment, and it will vary
  // depending on stage. For bb server and for personal aws dev accounts, it's currently configured
  // to point at the CategoryManagementTool's (CMT) alpha endpoint. The rationale for dev accounts
  // is that the logger infrastructure leads to non-compliance with a technology called Allegiance
  // which is needed on dev accounts but is not needed by CMT.
  url: 'https://cs3svgls15.execute-api.us-west-2.amazonaws.com/prod/v1/log',
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: true,
};

const logger = new KatalLogger(katalLoggerConfig);
logger.addErrorListener();
logger.addPerformanceListener();

const alreadyLogged = new Set<string>();
/**
 * Allows you to log warnings from a component render, without
 * spamming repeatedly when it re-renders.
 */
export const warnOnce = (message: string, error: Error, key: string) => {
  if (alreadyLogged.has(key)) {
    return;
  }
  alreadyLogged.add(key);
  void logger.warn(message, error);
};

/**
 * If a related issue is known and already logged,
 * you may not want to log new warnings.
 */
export const warnUnless = (message: string, error: Error, newKey: string, unlessKey: string) => {
  if (alreadyLogged.has(unlessKey)) {
    return;
  }
  warnOnce(message, error, newKey);
};

export default logger;
